import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import { T } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import RubriqLogo from '../images/rubriq-logo-rgb-color-light-32x119.jpg';
var RubriqHeader = function RubriqHeader() {
  var _useMatch = useMatch('/:lang/rubriq/:tab?/*'),
    _useMatch$params = _useMatch.params,
    _useMatch$params2 = _useMatch$params === void 0 ? {} : _useMatch$params,
    _useMatch$params2$tab = _useMatch$params2.tab,
    currentTab = _useMatch$params2$tab === void 0 ? 'editing' : _useMatch$params2$tab;
  var abstractWriterEnabled = false;
  var rubriqPlagiarismEnabled = featureEnabled('rubriq_plagiarism');
  var rubriqAbstractEnabled = featureEnabled('curie_abstract_writer');
  return /*#__PURE__*/React.createElement("div", {
    className: "rubriq-header-container border-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-75 g-padding mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-5 pb-4 d-flex flex-column align-items-start gap-3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "rubriq-headline"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.headline"
  })), /*#__PURE__*/React.createElement("p", {
    className: "fs-5"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.tagline"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-tabs"
  }, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "editing",
    className: "nav-link px-3 ".concat(currentTab === 'editing' ? 'active' : '')
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-file-pen"
  }), " ", /*#__PURE__*/React.createElement(T, {
    source: "editing"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "translation",
    className: "nav-link px-3 ".concat(currentTab === 'translation' ? 'active' : '')
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-language"
  }), " ", /*#__PURE__*/React.createElement(T, {
    source: "curie-translation"
  }))), abstractWriterEnabled && /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "abstract-writer",
    className: "nav-link px-3 ".concat(currentTab === 'abstract-writer' ? 'active' : '')
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-pen-clip"
  }), " ", /*#__PURE__*/React.createElement(T, {
    source: "curie.abstracts"
  }), /*#__PURE__*/React.createElement("span", {
    className: "badge bg-info  ms-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Beta"
  })))), rubriqPlagiarismEnabled && /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "plagiarism",
    className: "nav-link px-3 ".concat(currentTab === 'plagiarism' ? 'active' : '')
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-regular fa-file-check"
  }), ' ', /*#__PURE__*/React.createElement(T, {
    source: "plagiarism_check"
  }), /*#__PURE__*/React.createElement("span", {
    className: "badge ms-2 rubriq-badge flowing"
  }, /*#__PURE__*/React.createElement(T, {
    source: "New"
  })))), rubriqAbstractEnabled && /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "abstract",
    className: "nav-link px-3 ".concat(currentTab === 'abstract' ? 'active' : '')
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-regular fa-file-lines"
  }), ' ', /*#__PURE__*/React.createElement(T, {
    source: "curie.abstracts"
  }), /*#__PURE__*/React.createElement("span", {
    className: "badge ms-2 rubriq-badge flowing"
  }, /*#__PURE__*/React.createElement(T, {
    source: "New"
  })))))))));
};
export default RubriqHeader;